import React, { useState } from 'react';
import styled from 'styled-components';
import ChevronLeft from 'assets/icons/xpo/chevron-left.svg';
// import AddCommentIcon from 'assets/icons/add-comment.svg';
import { ToolbarButtonComponent } from '@ontruck/fe-ui';
import { NewCommentForm } from './NewCommentForm';

const IconLabel = styled.img`
  margin-left: auto;
  padding-right: 16px;
`;
const NewCommentButtonContainer = styled.div`
  margin-left: auto;
`;

const NewCommentButton = styled(ToolbarButtonComponent)`
  border-left: 1px solid var(--grey300);
  width: 53px;
  margin-right: 16px;
`;

const HeaderLabel = styled.span`
  padding: 16px;
`;
const Header = ({ className, label, icon, onClick, ticketId, onNewComment }) => {
  const [showNewCommentForm, setShowNewCommentForm] = useState(true);
  const handleCancel = () => {
    setShowNewCommentForm(false);
  };
  return (
    <>
      <div className={className} onClick={onClick}>
        <HeaderLabel>{label}</HeaderLabel>
        {icon && <IconLabel alt="arrow" src={ChevronLeft} />}
        {ticketId && (
          <NewCommentButtonContainer>
            <NewCommentButton onClick={() => setShowNewCommentForm(!showNewCommentForm)}>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_3472_4850)">
                  <path
                    d="M22 6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H18L22 24V6ZM16 13H13V16C13 16.55 12.55 17 12 17C11.45 17 11 16.55 11 16V13H8C7.45 13 7 12.55 7 12C7 11.45 7.45 11 8 11H11V8C11 7.45 11.45 7 12 7C12.55 7 13 7.45 13 8V11H16C16.55 11 17 11.45 17 12C17 12.55 16.55 13 16 13Z"
                    fill="#2396DC"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_3472_4850">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </NewCommentButton>
          </NewCommentButtonContainer>
        )}
      </div>
      {ticketId && showNewCommentForm && (
        <NewCommentForm ticketId={ticketId} onCancel={handleCancel} onNewComment={onNewComment} />
      )}
    </>
  );
};

export default styled(Header)`
  display: flex;
  align-items: center;
  height: ${({ headerHeight }) => (headerHeight ? headerHeight : 60)}px;
  cursor: ${({ onClick }) => (onClick ? 'pointer' : 'default')};
  background-color: var(--accent-color-gray);
  color: var(--grey700);
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 16px;
  text-transform: uppercase;
  :hover img {
    transform: scale(1.1);
  }
`;
